import { getFormatedDate } from "../../../helper";

export const renderMetrics = (
  data,
  handleViewPowerBi,
  RiskDialogBox,
  tabName,
) => {
  if (!data.length) {
    return null;
  }

  const getSortedMetricsData = (metricName, comparator) =>
    data
      ?.filter(
        (item) =>
          (item?.Metric || item?.Insight_Type || item?.Alert_type) ===
          metricName,
      )
      .sort((a, b) =>
        comparator(
          Number(b?.Metric_value || b?.Impact_Value),
          Number(a?.Metric_value || a?.Impact_Value),
        )
          ? 1
          : -1,
      );

  function truncateSubtitle(str) {
    if (typeof str !== "string") {
      return "";
    }
    const words = str.split(/\s+/).filter((word) => word !== "");
    if (words.length > 9) {
      return words.slice(0, 9).join(" ") + "...";
    } else {
      return str;
    }
  }
  const formatValue = (value, format) => {
    let numericValue = Number(value);
    if (isNaN(numericValue)) {
      console.error(`Invalid number: ${value}`);
      numericValue = 0; // Fallback to 0
    }

    let formattedText = "";

    if (format === "$") {
      const absValue = Math.abs(numericValue);

      if (absValue >= 1e6) {
        // Format for millions
        formattedText = `$${(absValue / 1e6).toFixed(1)}M`;
      } else if (absValue >= 1e3) {
        // Format for thousands
        formattedText = `$${(absValue / 1e3).toFixed(1)}K`;
      } else {
        // Format for values below 1000
        formattedText = `$${Math.round(absValue)}`;
      }

      // Handle negative values
      if (numericValue < 0) {
        formattedText = `-${formattedText}`;
      }

      // If numericValue is exactly 0
      if (numericValue === 0) {
        formattedText = "$0";
      }
    } else if (format === "") {
      formattedText = `${Math.round(numericValue)}`;
    } else {
      // Formatting as percentage
      formattedText = `${Math.round(numericValue)}%`;
    }

    return formattedText;
  };
  const metricRenderConfig = {
    SNO: [
      {
        metricName: "COF_Increase",
        title: "COF Increase",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `COF Increase increased in ${metric.Name}`,
      },
      {
        metricName: "Cost_Reduction",
        title: "Cost Reduction",
        format: "$",
        comparator: (value, other) => value < other,
        subTitle: (metric) => `Cost Reduction increased in ${metric.Name}`,
      },
      {
        metricName: "cost_per_case",
        title: "Cost Per Case",
        format: "$",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `Cost Per Case increased in ${metric.Name}`,
      },
    ],
    DOM: [
      {
        metricName: "COF_Increase",
        title: "Opportunity to increase",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          `COF to ${formatValue(metric?.Metric_value, "%")} in ${
            metric.Name
          } this week`,
      },
      {
        metricName: "Cost_Reduction",
        title: "Opportunity to reduce",
        format: "$",
        comparator: (value, other) => value < other,
        subTitle: (metric) =>
          `Cost by ${formatValue(metric?.Metric_value, "$")} in ${
            metric.Name
          } this week`,
      },
    ],
    DP: [
      {
        metricName: "Cost_Reduction",
        title: "Cost Reduction",
        format: "",
        comparator: (value, other) => value < other,
        subTitle: (metric) => `In ${metric.Name} this week`,
      },
      {
        metricName: "Payload_reduction",
        title: "Payload Decrease",
        format: "%",
        comparator: (value, other) => value < other,
        subTitle: (metric) => `In ${metric.Name} this week`,
      },
      {
        metricName: "Truckloads_Projected",
        title: "Cost reduce Opportunity",
        format: "$",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `In ${metric.Name} this week`,
      },
    ],
    DO: [
      {
        metricName: "Stockout_Count",
        title: "STRs need Approval",
        format: "",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          truncateSubtitle(
            `Due to rise of Stockout this week in ${metric.Name}`,
          ),
      },
      {
        metricName: "Past_due_STO",
        title: "Past due STOs",
        format: "",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          truncateSubtitle(`To be received at ${metric.Name} in last 2 weeks`),
      },
      {
        metricName: "Below_Min_Count",
        title: "Shipping Cost",
        format: "",
        comparator: (value, other) => value < other,
        subTitle: (metric) => `Reduction opportunity in ${metric.Name}`,
      },
      {
        metricName: "Rejected_STR",
        title: "Rejected STRs",
        format: "",
        comparator: (value, other) => value < other,
        subTitle: (metric) => `Reduction opportunity in ${metric.Name}`,
      },
    ],
    FGS: [
      {
        metricName: "Waste Risk",
        title: "Inventory waste risk",
        format: "$",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `Inventory at waste risk in ${metric?.Name}`,
      },
      {
        metricName: "Saving Opportunity",
        title: "Shipping Cost",
        format: "$",
        comparator: (value, other) => value < other,
        subTitle: (metric) => `Worth inventory movements DC${metric.Name}`,
      },
    ],
    CP: [
      {
        metricName: "Throughput",
        title: "Throughput",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          `increase in ${metric?.Entity} ${
            metric?.Name
          } in week of ${getFormatedDate(metric?.Date)}`,
      },
      {
        metricName: "LT-Over Utilization",
        title: "LT Over Capacity",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          `utilisation in ${metric?.Entity} ${
            metric?.Name
          } in week of ${getFormatedDate(metric?.Date)}`,
      },
      {
        metricName: "LT-Under Utilization",
        title: "LT Under Capacity",
        format: "%",
        comparator: (value, other) => value < other,
        subTitle: (metric) =>
          `utilisation in ${metric?.Entity} ${
            metric?.Name
          } in week of ${getFormatedDate(metric?.Date)}`,
      },
      {
        metricName: "ST-Over Utilization",
        title: "ST Over Capacity",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          `utilisation in ${metric?.Entity} ${
            metric?.Name
          } in week of ${getFormatedDate(metric?.Date)}`,
      },
      {
        metricName: "ST-Under Utilization",
        title: "ST Under Capacity",
        format: "%",
        comparator: (value, other) => value < other,
        subTitle: (metric) =>
          `utilisation in ${metric?.Entity} ${
            metric?.Name
          } in week of ${getFormatedDate(metric?.Date)}`,
      },
    ],
    DIP: [
      {
        metricName: "Throughput",
        title: "Throughput",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          `increase in ${metric?.Entity} ${
            metric?.Name
          } in week of ${getFormatedDate(metric?.Date)}`,
      },
      {
        metricName: "Waste Risk",
        title: "Inventory Waste Risk",
        format: "$",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          `utilisation in ${metric?.Entity} ${
            metric?.Name
          } in week of ${getFormatedDate(metric?.Date)}`,
      },
      {
        metricName: "LT-Over Utilization",
        title: "LT Over Capacity",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          `utilisation in ${metric?.Entity} ${
            metric?.Name
          } in week of ${getFormatedDate(metric?.Date)}`,
      },
      {
        metricName: "LT-Under Utilization",
        title: "LT Under Capacity",
        format: "%",
        comparator: (value, other) => value < other,
        subTitle: (metric) =>
          `utilisation in ${metric?.Entity} ${
            metric?.Name
          } in week of ${getFormatedDate(metric?.Date)}`,
      },
      {
        metricName: "LT-Over Utilization",
        title: "LT Over Capacity",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          `utilisation in ${metric?.Entity} ${
            metric?.Name
          } in week of ${getFormatedDate(metric?.Date)}`,
      },
      {
        metricName: "ST-Under Utilization",
        title: "ST Under Capacity",
        format: "%",
        comparator: (value, other) => value < other,
        subTitle: (metric) =>
          `utilisation in ${metric?.Entity} ${
            metric?.Name
          } in week of ${getFormatedDate(metric?.Date)}`,
      },
    ],
    DETENTION: [
      {
        metricName: "Incident rate increase MoM",
        title: "Incident rate increase MoM",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `at ${metric?.Entity} ${metric?.Name}`,
      },
      {
        metricName: "Incident rate increase WoW",
        title: "Incident rate increase WoW",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `at ${metric?.Entity} ${metric?.Name}`,
      },
      {
        metricName: "Pending action > 2 days",
        title: "Pending action > 2 days",
        format: "",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `at ${metric?.Entity} ${metric?.Name}`,
      },
    ],
    POOS: [
      {
        metricName: "RPOOS-Pending Review",
        title: "RPOOS-Pending Review",
        format: "",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          `In ${metric?.Entity} ${metric?.Name} as of ${getFormatedDate(metric.Genrated_date)}`,
      },
      {
        metricName: "NPOOS-Reject",
        title: "NPOOS-Reject",
        format: "$",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          `In ${metric?.Entity} ${metric?.Name} as of ${getFormatedDate(metric.Genrated_date)}`,
      },
      {
        metricName: "NPOOS-Pending Review",
        title: "NPOOS-Pending Review",
        format: "",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          `In ${metric?.Entity} ${metric?.Name} as of ${getFormatedDate(metric.Genrated_date)}`,
      },
      {
        metricName: "RPOOS-Reject",
        title: "RPOOS-Reject",
        format: "$",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          `In ${metric?.Entity} ${metric?.Name} as of ${getFormatedDate(metric.Genrated_date)}`,
      },
      {
        metricName: "NPOOS-Others",
        title: "NPOOS-Others",
        format: "$",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          `In ${metric?.Entity} ${metric?.Name} as of ${getFormatedDate(metric.Genrated_date)}`,
      },
      {
        metricName: "RPOOS-FQ: FG Quality Failures",
        title: "RPOOS-FQ: FG Quality Failures",
        format: "$",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          `In ${metric?.Entity} ${metric?.Name} as of ${getFormatedDate(metric.Genrated_date)}`,
      },
      {
        metricName: "RPOOS-DM: Demand Planning Issue",
        title: "RPOOS-DM: Demand Planning Issue",
        format: "$",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          `In ${metric?.Entity} ${metric?.Name} as of ${getFormatedDate(metric.Genrated_date)}`,
      },
      {
        metricName: "NPOOS-DM: Demand Planning Issue",
        title: "NPOOS-DM: Demand Planning Issue",
        format: "$",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          `In ${metric?.Entity} ${metric?.Name} as of ${getFormatedDate(metric.Genrated_date)}`,
      },
      {
        metricName: "RPOOS-Others",
        title: "RPOOS-Others",
        format: "$",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          `In ${metric?.Entity} ${metric?.Name} as of ${getFormatedDate(metric.Genrated_date)}`,
      },
    ],
    FF: [
      {
        metricName: "High Accuracy- Awards Short",
        title: "Award Shortage",
        format: "",
        comparator: (value, other) => value < other,
        subTitle: (metric) => `In high accuracy lane: ${metric.Name}`,
      },
      {
        metricName: "High Accuracy- No Awards",
        title: "No Contracts",
        format: "",
        comparator: (value, other) => value < other,
        subTitle: (metric) => `For high accuracy lane ${metric?.Name}`,
      },
      {
        metricName: "High Accuracy-Rewards Short",
        title: "Award Shortage",
        format: "",
        comparator: (value, other) => value < other,
        subTitle: (metric) => `In high accuracy lane: ${metric.Name}`,
      },
    ],
    RR: [
      {
        metricName: "STOs to Cancel from DC",
        title: "STOs to Cancel from DC",
        format: "",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          `From ${metric?.Entity} ${metric?.Name} For the event ${metric?.ScenarioName}`,
      },
      {
        metricName: "Diverts to DC",
        title: "Diverts to DC",
        format: "",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          `To ${metric?.Entity} ${metric?.Name} For the event ${metric?.ScenarioName}`,
      },
    ],
    NPS: [
      {
        metricName: "Capacity Breach",
        title: "Capacity Breach",
        format: "",
        comparator: (value, other) => value < other,
        subTitle: (metric) => `Weeks in DC  ${metric.Name}`,
      },
      {
        metricName: "Outbound Dock Capacity Limit",
        title: "Avg capacity utilization",
        format: "",
        comparator: (value, other) => value < other,
        subTitle: (metric) => `Weeks in DC ${metric.Name}`,
      },
      {
        metricName: "Revenue Decrease vs Baseline",
        title: "Revenue Decrease",
        format: "%",
        comparator: (value, other) => value < other,
        subTitle: (metric) => `In DC ${metric.Name} vs baseline`,
      },
      {
        metricName: "Cost Increase vs Baseline",
        title: "Cost Increase",
        format: "%",
        comparator: (value, other) => value < other,
        subTitle: (metric) => `In DC ${metric.Name} vs baseline`,
      },
    ],
    IF: [
      {
        metricName: "Cost Reduction",
        title: "Cost Reduction",
        format: "$",
        comparator: (value, other) => value < other,
        subTitle: (_metric) => `rejections last week`,
      },
      {
        metricName: "Waste Risk",
        title: "Waste Risk",
        format: "$",
        comparator: (value, other) => value < other,
        subTitle: (metric) => `${metric.Network} network this month`,
      },
      {
        metricName: "Over Capacity",
        title: "Over Capacity",
        format: "$",
        comparator: (value, other) => value < other,
        subTitle: (_metric) => `projected this fortnight`,
      },
      {
        metricName: "COF Improvement",
        title: "COF Improvement",
        format: "$",
        comparator: (value, other) => value < other,
        subTitle: (_metric) => `last week`,
      },
    ],

    SLP: [
      {
        metricName: "Confirm qty adjustment",
        title: "POs Confirmed qty adj",
        format: "",
        comparator: (value, other) => value < other,
        subTitle: (metric) =>
          `From future orders for ${metric?.Entity} ${metric.Name}`,
      },
      {
        metricName: "Low Payload or COF",
        title: "POs with Low Payload",
        format: "",
        comparator: (value, other) => value < other,
        // subTitle: (metric) => `In DC 5410 in next`,
      },
      {
        metricName: "ATP To confirm Quantity",
        title: "POs ATP to confirm Quantity",
        format: "",
        comparator: (value, other) => value < other,
        subTitle: (metric) =>
          `From future orders for ${metric?.Entity} ${metric.Name}`,
      },
    ],

    IOFPB: [
      {
        metricName: "2S -Increase over 2 wks",
        title: "KE Reason Code Increase",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `% for ${metric?.Entity} ${metric?.Name}`,
      },
      {
        metricName: "KE -Increase over 2 wks",
        title: "KE Reason Code Increase",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `% for ${metric?.Entity} ${metric?.Name}`,
      },
      {
        metricName: "LS -Increase over 2 wks",
        title: "LS Reason Code Increase",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `% for ${metric?.Entity} ${metric?.Name}`,
      },
      {
        metricName: "UK -Increase over 2 wks",
        title: "UK Reason Code Increase",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `% for ${metric?.Entity} ${metric?.Name}`,
      },
      {
        metricName: "Wrong_reason_code",
        title: "Wrong Reason Code",
        format: "",
        comparator: (value, other) => value > other,
        subTitle: (metric) =>
          metric?.Entity === "Customer"
            ? `usage for Customer`
            : `usage by ${metric?.Entity}`,
      },
    ],
    TM: [
      {
        metricName: "COST INCREASE MOM",
        title: "Cost Increase",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `For ${metric.Name} in last 1 month`,
      },
      {
        metricName: "TRUCK SHORTAGE",
        title: "Truck Shortage",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `For ${metric.Name} in last 1 month`,
      },
    ],
    ERM: [
      {
        metricName: "Late Loads 1M WoW Increase",
        title: "Late Loads 1M WoW Increase",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `Recommended for ${metric.Name}`,
      },
      {
        metricName: "Late Loads OM WoW Increase",
        title: "Late Loads OM WoW Increase",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `Recommended for ${metric.Name}`,
      },
      {
        metricName: "Late Loads FA WoW Increase",
        title: "Late Loads FA WoW Increase",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `Recommended for ${metric.Name}`,
      },
      {
        metricName: "Quantity Cuts  CX WoW Increase",
        title: "Quantity Cuts  CX WoW Increase",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `Recommended for ${metric.Name}`,
      },
      {
        metricName: "Late Loads CB WoW Increase",
        title: "Late Loads CB WoW Increase",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `Recommended for ${metric.Name}`,
      },
      {
        metricName: "Late Loads CF WoW Increase",
        title: "Late Loads CF WoW Increase",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `Recommended for ${metric.Name}`,
      },
      {
        metricName: "Quantity Cuts  3B WoW Increase",
        title: "Quantity Cuts  3B WoW Increase",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `Recommended for ${metric.Name}`,
      },
      {
        metricName: "Exception Y40 WoW Increase",
        title: "Exception Y40 WoW Increase",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `Recommended for ${metric.Name}`,
      },
      {
        metricName: "Late Loads (On-time) WoW Increase",
        title: "Late Loads (On-time) WoW Increase",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `Recommended for ${metric.Name}`,
      },
      {
        metricName: "Exception Y39 WoW Increase",
        title: "Exception Y39 WoW Increase",
        format: "%",
        comparator: (value, other) => value > other,
        subTitle: (metric) => `Recommended for ${metric.Name}`,
      },
    ],
  };

  const selectedMetrics = [];
  metricRenderConfig[tabName]?.forEach(
    ({ metricName, title, format, comparator, subTitle }) => {
      const sortedMetrics = getSortedMetricsData(metricName, comparator);
      sortedMetrics?.forEach((metric) => {
        if (selectedMetrics?.length < 4) {
          selectedMetrics.push(
            <RiskDialogBox
              key={`${metric?.Alert_id}-${selectedMetrics?.length}`}
              value={Number(
                metric?.Metric_value ||
                  metric?.Alert_value ||
                  metric?.Impact_Value,
              )}
              alerts={metric}
              handleViewPowerBi={handleViewPowerBi}
              maxValue="100"
              format={format}
              title={title}
              subTitle={subTitle(metric)}
            />,
          );
        }
      });
    },
  );

  return selectedMetrics.slice(0, 4);
};
